import React from "react";
import {Button,} from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import EditIcon from '@mui/icons-material/Edit';

export default function DHButtonEdit({label, working, disabled, onClick, style}) {

    return <Button variant="contained" disabled={disabled || working} onClick={() => onClick()} startIcon={working ? <CircularProgress size={20}/> : <EditIcon/>}
                   style={{textTransform: "none", letterSpacing:"0.1em", ...style}}>{label !== undefined ? label : "Bearbeiten"}</Button>
}